import { render, staticRenderFns } from "./DominioEdit.vue?vue&type=template&id=5b130ac2&"
import script from "./DominioEdit.vue?vue&type=script&lang=js&"
export * from "./DominioEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports